"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.indigoPalette = void 0;
var themeCreator_1 = __importDefault(require("./themeCreator"));
exports.indigoPalette = {
    component: {
        answerSelectedColor: 'rgb(0, 181, 155)',
        answerUnselectedColor: 'rgb(225, 225, 225)',
        continueButtonColor: 'rgb(82, 0, 188)',
        continueButtonHoverColor: 'rgb(54,0,123)',
        backButtonColor: 'rgb(237,237,237)',
        backButtonHoverColor: 'rgb(223,223,223)',
        progressBarFilledColor: 'rgb(0, 181, 155)',
        progressBarUnfilledColor: 'rgb(247,247, 247)',
        scrollIndicatorColor: 'rgb(0, 0, 0)',
    },
    background: {
        answerBackgroundColor: 'rgb(251, 251, 251)',
        secondaryBackgroundColor: 'rgb(247, 247, 247)',
        widgetBackgroundColor: 'rgb(255,255,255)',
    },
    text: {
        primaryTextColor: 'rgb(0, 0, 0)',
        continueButtonTextColor: 'rgb(255, 255, 255)',
        secondaryTextColor: 'rgb(0, 0, 0)',
    },
    status: {
        disabled: 'rgb(134, 134, 134)',
        error: 'rgb(249, 98, 78)',
    },
};
var indigoTheme = (0, themeCreator_1.default)(exports.indigoPalette);
exports.default = indigoTheme;
//# sourceMappingURL=indigoTheme.js.map